module.exports = __webpack_public_path__ + "img/pc-escritorio.6844b7ac.png";